import { parsePaise } from './allocation';

export interface OrderAdvanceTerms {
  shipmentId: number;
  partnerFreight: string;
  advanceCap: string;
}

/** The API rounds freight × an integer percentage to whole rupees (HALF_UP).
 * Recover a rate only when the supplied order cap has exactly one matching rate.
 * Small/zero freight or mismatched/stale caps cannot establish an applicable rate.
 */
export function orderAdvancePercentage(terms: OrderAdvanceTerms, currentCap?: string | null) {
  try {
    const freight = parsePaise(terms.partnerFreight);
    const cap = parsePaise(terms.advanceCap);
    if (freight <= 0n || cap < 0n || (currentCap != null && parsePaise(currentCap) !== cap))
      return undefined;
    const matches = Array.from({ length: 101 }, (_, pct) => pct).filter(
      (pct) => ((freight * BigInt(pct) + 5000n) / 10000n) * 100n === cap,
    );
    return matches.length === 1 ? matches[0] : undefined;
  } catch {
    return undefined;
  }
}
